import { Component, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';

@Component({
	selector: 'app-input-control',
	standalone: true,
	imports: [ReactiveFormsModule, NzFormModule, NzInputModule],
	templateUrl: './input-control.html',
	styleUrl: './input-control.scss',
})
export class InputControl {
	label = input.required<string>();
	controlName = input.required<string>();
	placeholder = input<string>('');
	required = input<boolean>(true);
	minLength = input<number | null>(null);
	type = input<string>('text');
	formGroup = input.required<FormGroup>();
	min = input<number | null>(null);
	max = input<number | null>(null);
	disabled = input<boolean>(false);
}
